import React from 'react';
import { Button, Form, Grid, Icon, Loader, Popup, Select, Table } from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';
import { HeaderCursor } from './css';

import ResultsPerPageDropdown from '../../Assets/util/ResultsPerPageDropdown';
import PaginationFront from '../../util/PaginationFront';
import SearchTableData from '../../util/SearchTableData';
import {extractFileNameFromHeaders} from "../../DegreeDocumentPrint/util/util";
import download from "downloadjs";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


const NoPreviousGradesMessage = () => <p><FormattedMessage id="professorInputGrades.PreviousGradesMessage" /></p>;

export default class studentsWithGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [...this.props.data],
            results: [],
            grade: '',

            showFiltersOnButton: false,
            showGradesMode: false,
            showStudentsWithGradesMode: true,

            confirmation: false,

            showStudentInfo: false,
            studentId: '',
            sspId: '',
            studyProgramId: '',

            firstName: null,
            lastName: null,
            index: null,
            studyProgramIdFilter: null,
            studyTypeId: null,
            markId: null,

            page: 0,
            postsPerPage: JSON.parse(localStorage.getItem('postsPerPageTab1')),
            activePage: 1,
            loading: false,

            resetValue: false,
            //front filter properties
            filterDataMode: false
        };


        this.handleGradeChange = this.handleGradeChange.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.confirmGrade = this.confirmGrade.bind(this);
        this.cancelGrade = this.cancelGrade.bind(this);
        this.activateGrades = this.activateGrades.bind(this);
        this.handleResultsPerPageChange = this.handleResultsPerPageChange.bind(this);
        this.getResults = this.getResults.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getStudentGrades = this.getStudentGrades.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.data !== this.props.data){
            let {departmentId, studyProgramBasicId, studyType, sortingOption}= this.state;
            this.props.frontFilterData(this.props.data, departmentId, studyProgramBasicId, studyType ? studyType.id : null, sortingOption, true);
            this.setState({
                showGradesMode: null,
                confirmation: false,
                data:this.props.data,
                results: [],
                loader: false
            })
        }
    }

    getDataToRender() {

        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        if (this.state.filterDataMode) {
            return this.props.filterData;
        }
        return this.state.data;
    }

    handleGradeChange({ value }, index) {
        this.setState({ grade: value });
    }

    handleInputChange(e, { name, value }) {

        this.setState({ [name]: value, resetValue: true },()=>{
            let {departmentId, studyProgramBasicId, studyType, sortingOption}= this.state;
            this.setState({filterDataMode:true});
            this.props.frontFilterData(this.props.data, departmentId, studyProgramBasicId, studyType?studyType.id:null, sortingOption, true)

        });
    }

    confirmGrade(index, optlock, studentGradedActivityId, markId) {
        this.setState({loader: true})
        const docRequest = {
            optlock,
            studentGradedActivityId,
            markId,
        };

        axios.put('/professor/update-grade', { ...docRequest })
            .then(res => {
                toast(<FormattedMessage id="professorInputGrades.toastStudentGradeEdited" />);
                this.setState({loader: false})
                this.activateGrades(index);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);

                this.setState({
                    showGradesMode: null})
            })
            .catch(err => {
                console.log('Pogrešno!');
                toast(<FormattedMessage id="professorInputGrades.toastStudentGradeEditFailed" />);

                this.setState({loader: false})
                this.activateGrades(index);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                this.setState({
                    showGradesMode: null})

                // toast(<FormattedMessage id="professorInputGrades.toastStudentGradeEditFailed" />);
            });
    }

    cancelGrade(index, optlock, studentGradedActivityId, markId) {
        axios.put(`/professor/delete-mark/student-graded-activity/${studentGradedActivityId}/`)
            .then(res => {
                toast(<FormattedMessage id="professorInputGrades.toastStudentGradeCancel" />);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true, this.state.page, this.state.resultsPerPage);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false, this.state.page, this.state.resultsPerPage);


            })
            .catch(err => {
                console.log('Pogrešno!');
                toast(<FormattedMessage id="professorInputGrades.toastStudentGradeCancelFailed" />);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true, this.state.page, this.state.resultsPerPage);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false, this.state.page, this.state.resultsPerPage);
                // this.activateGrades(index);
                // this.setState({ confirmation: false });
               // toast(<FormattedMessage id="professorInputGrades.toastStudentGradeCancelFailed" />);
            });
    }

    activateGrades(index, studentId) {
        if (index === this.state.showGradesMode) {
            this.setState({ currentStudentId: null, showGradesMode: null, grade: '' });
        } else { this.setState({ currentStudentId: studentId ,showGradesMode: index, grade: '' }); }
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })
    // eslint-disable-next-line no-dupe-class-members
    handleResultsPerPageChange(e, { value }) {
        if(value === 0){
            localStorage.setItem('postsPerPageTab1', JSON.stringify(this.getDataToRender().length));
            this.setState({ activePage: 1, postsPerPage: this.getDataToRender().length });
        }else{
            localStorage.setItem('postsPerPageTab1', JSON.stringify(value));
            this.setState({ activePage: 1, postsPerPage: value  });
        }

    }

    getResults(results) {
        this.setState({ results, resetValue: false });
        this.handlePaginationChange({}, {activePage: 1})
    }

    getStudentGrades() {
        let obj = {
            gradedActivityId: localStorage.getItem('gradedActivityId'),
            language: 'bs'
        };
        axios({
            method: 'post',
            url: '/documents/exam-marks-without-fullname',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }

    render() {
        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        if (this.state.showStudentInfo === true) {
            return (<Redirect
                push
                to={{
                    pathname: localStorage.getItem('path'),
                    state: { studentId: this.state.studentId, sspId: this.state.sspId, studyProgramId: this.state.studyProgramId }
                }}
            />);
        }
        return (
            <div>
                {(this.getDataToRender().length > 0) && <ResultsPerPageDropdown
                    resultsPerPage={this.state.postsPerPage === this.getDataToRender().length ? 0 : this.state.postsPerPage}
                    onResultsPerPageChange={this.handleResultsPerPageChange}
                />}
                <br /><br />
                {(this.state.loading) ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :


                        <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={this.state.showGradesMode?18:16}>
                                         <span>
                                                <Grid stackable columns={2} >

                                                         <Grid.Column width={this.state.showGradesMode?18:16}>
                                                             <SearchTableData profMozilla data={this.getDataToRender()} getResults={this.getResults} resetValue={this.state.resetValue} disabled={this.state.disabledFilter} filterItem={['index','firstName', 'lastName','name','studyProgramBasicName']}/>
                                                         </Grid.Column>
                                                    {/*<Grid.Column width={2} style={{ paddingRight: '18px' }}>*/}
                                                    {/*        <Popup*/}
                                                    {/*            trigger={*/}
                                                    {/*                <Button*/}
                                                    {/*                    animated="vertical"*/}
                                                    {/*                    fluid*/}
                                                    {/*                    color="red"*/}
                                                    {/*                    basic*/}
                                                    {/*                    onClick={this.getStudentGrades}*/}
                                                    {/*                >*/}
                                                    {/*                    <Button.Content hidden> <Icon name="download" /></Button.Content>*/}
                                                    {/*                    <Button.Content visible>*/}
                                                    {/*                        PDF*/}
                                                    {/*                    </Button.Content>*/}
                                                    {/*                </Button>*/}
                                                    {/*            }*/}
                                                    {/*            content="Ocijenjeni studenti po indexima"*/}
                                                    {/*            hideOnScroll*/}
                                                    {/*            position="top center"*/}
                                                    {/*        />*/}
                                                    {/*    </Grid.Column>*/}
                                                     </Grid>

                                            </span>
                                        <Grid columns={1}>
                                            <Grid.Column>
                                            </Grid.Column>
                                        </Grid>

                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={this.state.showGradesMode?18:16}>
                                        <Form>
                                            <Form.Group  widths="equal">
                                                <Form.Field
                                                    clearable
                                                    width={4}
                                                    required
                                                    control={Select}
                                                    placeholder="Odsjek"
                                                    value={this.state.departmentId}
                                                    name="departmentId"
                                                    options={this.props.departments}
                                                    onChange={this.handleInputChange}
                                                />
                                                <Form.Field
                                                    clearable
                                                    width={4}
                                                    required
                                                    control={Select}
                                                    placeholder="Studijski program"
                                                    value={this.state.studyProgramBasicId}
                                                    name="studyProgramBasicId"
                                                    options={this.props.studyPrograms}
                                                    onChange={this.handleInputChange}
                                                />
                                                <Form.Field
                                                    clearable
                                                    width={4}
                                                    required
                                                    control={Select}
                                                    placeholder="Tip studiranja"
                                                    value={this.state.studyType}
                                                    name="studyType"
                                                    options={this.props.studyTypes}
                                                    onChange={this.handleInputChange}
                                                />
                                                <Form.Field
                                                    clearable
                                                    width={4}
                                                    required
                                                    control={Select}
                                                    placeholder="Sortiranje"
                                                    value={this.state.sortingOption}
                                                    name="sortingOption"
                                                    options={this.props.sortingOptions}
                                                    onChange={this.handleInputChange}
                                                />
                                            </Form.Group>

                                        </Form>


                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell>R. br.</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={3} >
                                        <FormattedMessage id="common.index" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell
                                        verticalAlign="middle"
                                        colSpan={2}
                                    >

                                        <FormattedMessage id="common.lastName" />


                                    </Table.HeaderCell>
                                    <Table.HeaderCell
                                        colSpan={2}
                                    >
                                        <FormattedMessage id="common.firstName" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={4}>
                                        <FormattedMessage id="professorInputGrades.studyProgram" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={'2'}>
                                        <FormattedMessage id="common.grade" />
                                    </Table.HeaderCell>
                                    {this.state.showGradesMode && <Table.HeaderCell colSpan={'2'}></Table.HeaderCell>}
                                    <Table.HeaderCell colSpan={'2'}></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            {currentPosts.length ?
                            <Table.Body> {currentPosts.map((el, index) =>
                                (<Table.Row key={el.studentGradedActivityId} style={HeaderCursor}>

                                    <Table.Cell verticalAlign="middle" >
                                        {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                    </Table.Cell>
                                        <Table.Cell
                                            colSpan={3}
                                            verticalAlign="middle"
                                        >
                                            <Grid columns={2} centered stackable>
                                                <Grid.Column width="10">
                                                    {el.index}
                                                </Grid.Column>
                                                <Grid.Column verticalAlign="middle" textAlign="right" width="6">
                                            <span>
                                                {<Popup content={el.studyType} hideOnScroll position="top center" trigger={<span style={{ color: '#a6a4a1' }}>
                                                    {el.studyType === 'redovan-samofinansirajući' && 'RSF'}
                                                    {el.studyType === 'redovan' && 'R'}
                                                    {el.studyType === 'vanredan' && 'V'}
                                                    {el.studyType === 'paralelan' && 'P'}
                                                    {el.studyType === 'DL studij' && 'DL'}

                                                </span>} />}
                                                   </span>
                                                </Grid.Column>
                                            </Grid>



                                        </Table.Cell>

                                        <Popup
                                            content={<FormattedMessage id="professorInputGrades.showStudentInfo" />}
                                            hideOnScroll
                                            position="top center"
                                            trigger={
                                                <Table.Cell
                                                    colSpan={2}
                                                    verticalAlign="middle"
                                                    onClick={() => this.setState({
                                                        studentId: el.studentId, sspId: el.studentStudyProgramId, studyProgramId: el.studyProgramId, showStudentInfo: true
                                                    })}
                                                >
                                                    {el.lastName}
                                                </Table.Cell>


                                            }
                                        />

                                    <Popup
                                        content={<FormattedMessage id="professorInputGrades.showStudentInfo" />}
                                        hideOnScroll
                                        position="top center"
                                        trigger={

                                            <Table.Cell
                                                colSpan={2}
                                                verticalAlign="middle"
                                                onClick={() => this.setState({
                                                    studentId: el.studentId, sspId: el.studentStudyProgramId, studyProgramId: el.studyProgramId, showStudentInfo: true
                                                })}
                                            >
                                                {el.firstName}
                                            </Table.Cell>


                                        }
                                    />
                                    <Table.Cell
                                        verticalAlign="middle"
                                        colSpan={4}
                                    >
                                        {

                                            el.departments ? el.departments.map(e => (<div>

                                                    {e.name === el.studyProgramBasicName?
                                                        e.name
                                                        :

                                                        e.name && e.name !== '-'?
                                                            //ima odsjek i nije crtica
                                                            <span>
                                                <strong>{e.name}</strong> <span> {el.studyProgramBasicName && el.studyProgramBasicName !== '-' ? (' | ' + el.studyProgramBasicName) : ''}</span>
                                            </span>
                                                            :
                                                            //nema odsjek ili je crtica
                                                            el.studyProgramBasicName ? el.studyProgramBasicName : ''

                                                    }
                                                </div>
                                            )) : el.studyProgramBasicName ? el.studyProgramBasicName :''

                                        }
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle"colSpan={'2'}>
                                        {el.grade}
                                    </Table.Cell>
                                    {this.state.showGradesMode && <Table.Cell verticalAlign="middle" colSpan={'2'}>
                                        {this.state.showGradesMode === el.index && <Form.Dropdown
                                            placeholder={<FormattedMessage id="professorInputGrades.selectGrade" />}
                                            value={this.state.grade}
                                            onChange={(e, event) => this.handleGradeChange(event, el.index)}
                                            name="grade"
                                            options={this.props.marks.filter(el => (el.key_ !== 'nz' && el.key_ !== 'no' && el.key_ !== 'nonp' && el.key_ !== 'f' && el.key_ !== 'not_defended' && el.key_ !== 'uo'))}
                                            search
                                            fluid
                                        />}
                                    </Table.Cell>}
                                    <Table.Cell textAlign="center" verticalAlign="middle" colSpan={'2'}>

                                        {this.state.showGradesMode === el.index ?
                                            <Popup
                                                content={<FormattedMessage id="professorInputGrades.confirmGrade" />}
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        loading={this.state.loader}
                                                        basic="true"
                                                        circular
                                                        icon={"check"}
                                                        size="small"
                                                        color="green"
                                                        onClick={
                                                            () => {
                                                                this.confirmGrade(el.index, el.optlock, el.id, this.state.grade);
                                                            }
                                                        }
                                                    >
                                                    </Button>
                                                }
                                            />

                                            : !this.state.confirmation &&
                                                <Popup
                                                    content={<FormattedMessage id="common.edit" />}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                          disabled={this.state.showGradesMode && this.state.currentStudentId !== el.studentId}
                                                            basic="true"
                                                            circular
                                                            icon="pencil"
                                                            size="small"
                                                            color="blue"
                                                            onClick={
                                                                () => {
                                                                    this.activateGrades(el.index, el.studentId);
                                                                }
                                                            }
                                                        >
                                                        </Button>
                                                    }
                                                />

                                        }
                                        {this.state.showGradesMode === el.index ?
                                            <Popup
                                                content={<FormattedMessage id="common.cancelO" />}
                                                position="top center"
                                                trigger={
                                                    <Button

                                                        basic="true"
                                                        circular
                                                        icon="close"
                                                        size="small"
                                                        color="red"
                                                        onClick={
                                                            () => {
                                                                this.activateGrades(el.index);
                                                            }
                                                        }
                                                    >
                                                    </Button>
                                                }
                                            />

                                            : this.state.confirmation === el.index ?
                                                this.state.loader?<div style={{ paddingTop: '5px', paddingBottom: '5px' }}><Loader size={'small'} active inline="centered" /></div>:
                                                <Form>
                                                    <h5><FormattedMessage id="common.areYouSure" /></h5>
                                                    <Button.Group compact>
                                                        <Button
                                                            basic="true"
                                                            color="blue"
                                                            onClick={() => {this.setState({loader:true}); this.cancelGrade(el.index, el.optlock, el.id); }}
                                                        > <FormattedMessage id="common.yes" /></Button>
                                                        <Button
                                                            basic="true"
                                                            color="red"
                                                            onClick={() => { this.setState({ confirmation: false }); }}
                                                        > <FormattedMessage id="common.no" />

                                                        </Button>
                                                    </Button.Group>
                                                </Form>
                                                :
                                                <Popup
                                                    content={<FormattedMessage id="professorInputGrades.cancelGrade" />}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            disabled={this.state.showGradesMode && this.state.currentStudentId !== el.studentId}
                                                            basic="true"
                                                            circular
                                                            icon="close"
                                                            size="small"
                                                            color="red"
                                                            onClick={
                                                                () => {
                                                                    this.setState({ confirmation: el.index });
                                                                }}
                                                        >
                                                        </Button>
                                                    }
                                                />

                                        }
                                    </Table.Cell>
                                </Table.Row>
                                ))}
                            </Table.Body> : <Table.Body>
                                    <Table.Row >
                                        <Table.Cell verticalAlign="middle" colSpan={10} ><NoPreviousGradesMessage /></Table.Cell></Table.Row></Table.Body>}
                        </Table>


                }
                {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/StudentsWithGrades.js